const items = state => state.items.data
const country = state => state.country.data
const city = state => state.city.data
const error = state => state.error
const isLoading = state => state.isLoading
const isLoadingCountries = state => state.isLoadingCountries
const isLoadingDestination = state => state.isLoadingDestination
const destinationCities = state => state.destinationCities.data
const errorDestination = state => state.errorDestination

const cityPortsOrigin = state => state.cityPortsOrigin
const cityPortsDestination = state => state.cityPortsDestination
const isLoadingCityPortsOrigin = state => state.isLoadingCityPortsOrigin
const isLoadingCityPortsDestination = state => state.isLoadingCityPortsDestination
const errorCityPortsOrigin = state => state.errorCityPortsOrigin
const errorCityPortsDestination = state => state.errorCityPortsDestination

const getProvincesByCountryId = state => state.provincesByCountryId.data
const errorProvincesByCountryId = state => state.errorProvincesByCountryId
const isLoadingProvincesByCountryId = state => state.isLoadingProvincesByCountryId

const getCityByProvinceId = state => state.cityByProvinceId.data
const errorCityByProvinceId = state => state.errorCityByProvinceId
const isLoadingCityByProvinceId = state => state.isLoadingCityByProvinceId

const getDistrictByCityId = state => state.districtByCityId.data
const errorDistrictByCityId = state => state.errorDistrictByCityId
const isLoadingDistrictByCityId = state => state.isLoadingDistrictByCityId

const getSubdistrictByDistrictId = state => state.subdistrictByDistrictId.data
const errorSubdistrictByDistrictId = state => state.errorSubdistrictByDistrictId
const isLoadingSubdistrictByDistrictId = state => state.isLoadingSubdistrictByDistrictId
export default {
  isLoading,
  items,
  error,
  country,
  city,
  isLoadingCountries,
  isLoadingDestination,
  destinationCities,
  errorDestination,
  cityPortsOrigin,
  cityPortsDestination,
  isLoadingCityPortsOrigin,
  isLoadingCityPortsDestination,
  errorCityPortsOrigin,
  errorCityPortsDestination,
  
  getProvincesByCountryId,
  errorProvincesByCountryId,
  isLoadingProvincesByCountryId,

  getCityByProvinceId,
  errorCityByProvinceId,
  isLoadingCityByProvinceId,

  getDistrictByCityId,
  errorDistrictByCityId,
  isLoadingDistrictByCityId,

  getSubdistrictByDistrictId,
  errorSubdistrictByDistrictId,
  isLoadingSubdistrictByDistrictId

}



// WEBPACK FOOTER //
// ./src/store/modules/city/getters.js